const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");

const getIsVehicleRegistrationByCustomerSelected = registrationType => {
  return registrationType === VEHICLE_REGISTRATION_METHOD.MYSELF;
};

module.exports = { getIsVehicleRegistrationByCustomerSelected };
